import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactForm from "./sections/ContactForm";
import LocationAndDetails from "./sections/LocationAndDetails";
import StayConnected from "./sections/StayConnected";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactForm />
      <LocationAndDetails />
      <StayConnected />
      <Footer />
    </div>;
}